import { render, staticRenderFns } from "./AnnouncementBanners.vue?vue&type=template&id=5fa6771d&scoped=true&lang=pug"
import script from "./AnnouncementBanners.vue?vue&type=script&lang=js"
export * from "./AnnouncementBanners.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementBanners.vue?vue&type=style&index=0&id=5fa6771d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa6771d",
  null
  
)

export default component.exports